<template>
  <div>
    <div class="create-destination" :class="`destination-${state}-form-on`">
      <form id="destination_type_form">
        <div class="card card-custom gutter-b">
          <div class="card-body">
            <p>نوع مقصد خود را انتخاب کنید</p>
            <div class="d-flex flex-wrap justify-content-center">
              <div
                v-for="(value, key) in creatableDestinationNames"
                :key="key"
                class="card m-2 py-5 px-8 text-center cursor-pointer destination-type-card"
                @click="changeState(key)"
              >
                <div class="symbol symbol-45 mr-3 text-center">
                  <img
                    class="mx-auto"
                    :alt="value"
                    :src="`/media/destinations/${key}.png`"
                  />
                </div>
                <div class="mt-3 font-size-sm">{{ value }}</div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <CrCustomDestination
        ref="custom"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrCustomDestination>
      <CrFacebookDestination
        ref="facebook"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrFacebookDestination>
      <CrInstagramDestination
        ref="instagram"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrInstagramDestination>

      <CrInstagramRtmpDestination
          ref="instagramRtmp"
          :isCompany="isCompany"
          :isAdmin="isAdmin"
      ></CrInstagramRtmpDestination>

      <CrYoutubeDestination
        ref="youtube"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrYoutubeDestination>
      <CrTwitterDestination
        ref="twitter"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrTwitterDestination>
      <CrTwitchDestination
        ref="twitch"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrTwitchDestination>
      <CrAparatDestination
        ref="aparat"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrAparatDestination>
      <CrRubikaDestination
        ref="rubika"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrRubikaDestination>
      <CrSoroushDestination
        ref="soroushplus"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrSoroushDestination>
      <CrTekyeDestination
        ref="tekye"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrTekyeDestination>
      <CrArvancloadDestination
        ref="arvancload"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrArvancloadDestination>
      <CrShadDestination
        ref="shad"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrShadDestination>
      <CrTelegramDestination
        ref="telegram"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrTelegramDestination>
      <CrEitaaDestination
        ref="eitaa"
        :isCompany="isCompany"
        :isAdmin="isAdmin"
      ></CrEitaaDestination>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/destinations/create.scss";
</style>

<script>
import CrCustomDestination from "@/view/pages/destinations/create-comp/CrCustomDestination";
import CrFacebookDestination from "@/view/pages/destinations/create-comp/CrFacebookDestination";
import CrInstagramDestination from "@/view/pages/destinations/create-comp/CrInstagramDestination";
import CrInstagramRtmpDestination from "@/view/pages/destinations/create-comp/CrInstagramRtmpDestination";
import CrYoutubeDestination from "@/view/pages/destinations/create-comp/CrYoutubeDestination";
import CrTwitterDestination from "@/view/pages/destinations/create-comp/CrTwitterDestination";
import CrTwitchDestination from "@/view/pages/destinations/create-comp/CrTwitchDestination";
import CrAparatDestination from "@/view/pages/destinations/create-comp/CrAparatDestination";
import CrRubikaDestination from "@/view/pages/destinations/create-comp/CrRubikaDestination";
import CrSoroushDestination from "@/view/pages/destinations/create-comp/CrSoroushDestination";
import CrTekyeDestination from "@/view/pages/destinations/create-comp/CrTekyeDestination";
import CrArvancloadDestination from "@/view/pages/destinations/create-comp/CrArvancloadDestination";
import CrShadDestination from "@/view/pages/destinations/create-comp/CrShadDestination";
import CrTelegramDestination from "@/view/pages/destinations/create-comp/CrTelegramDestination";
import CrEitaaDestination from "@/view/pages/destinations/create-comp/CrEitaaDestination";
import instagram from "@/core/mixins/instagram";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  SET_ACTIONS,
  SHOW_ACTIONS_BAR
} from "@/core/services/store/actions.module";
import { STORE_DESTINATION } from "@/core/services/store/destinations.module";
import { mapGetters } from "vuex";

export default {
  name: "destinations-create",
  mixins: [instagram],
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      state: "type"
    };
  },
  components: {
    CrCustomDestination,
    CrFacebookDestination,
    CrInstagramDestination,
    CrInstagramRtmpDestination,
    CrYoutubeDestination,
    CrTwitterDestination,
    CrTwitchDestination,
    CrAparatDestination,
    CrRubikaDestination,
    CrSoroushDestination,
    CrTekyeDestination,
    CrArvancloadDestination,
    CrShadDestination,
    CrTelegramDestination,
    CrEitaaDestination

  },
  mounted() {
    let destinationRoute = "destinations-index";
    if (this.isCompany) {
      destinationRoute = "company-destinations-index";
    }
    if (this.isAdmin) {
      destinationRoute = "admin-destinations-index";
    }
    this.setBreadcrumbs();

    this.$store.commit(SHOW_ACTIONS_BAR, false);
    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: "ذخیره",
          event: "save-destination-event",
          class: "btn-primary",
          id: "save-destination-btn"
        },
        {
          name: "بازگشت",
          event: "go-back-event",
          id: "go-back-btn"
        }
      ]
    });

    this.eventHub.$on("save-destination-event", () => {
      let $this = this.$refs[this.state];
      let data = $this.form;
      data.type = this.destinationValues[this.state];

      if (this.state === "instagram") {
        data.details.username = data.name;
      }

      if (this.isCompany || this.isAdmin) {
        data["user"] = this.$route.params.id;
        data.user = this.$route.params.id;
      }

      $this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-destination-btn");
          this.disableBtn(submitBtn);
          this.$store
            .dispatch(STORE_DESTINATION, data)
            .then(destination => {
              if (this.state === "instagram") {
                this.loginToInstagram(destination.id);
              }
              this.$router.push({
                name: destinationRoute
              });

              this.enableBtn(submitBtn);
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    });
    this.eventHub.$on("go-back-event", () => {
      this.changeState("type");
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["save-destination-event", "go-back-even"]);
    this.$store.commit(SHOW_ACTIONS_BAR, true);
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "creatableDestinationNames",
      "destinationValues"
    ])
  },
  methods: {
    setBreadcrumbs() {
      let destinationsRouteName = "destinations-index";

      let items = [];
      if (this.isCompany) {
        destinationsRouteName = "company-destinations-index";

        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        destinationsRouteName = "admin-destinations-index";

        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }

      items.push({ title: "مقصد‌ها", route: { name: destinationsRouteName } });
      items.push({ title: "افزودن" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    changeState(e) {
      if (e === "type") {
        this.$store.commit(SHOW_ACTIONS_BAR, false);
      } else {
        this.$store.commit(SHOW_ACTIONS_BAR, true);
      }
      this.state = e;
    }
  }
};
</script>
